import { render, staticRenderFns } from "./CCModal.vue?vue&type=template&id=010e2b84&scoped=true&"
import script from "./CCModal.vue?vue&type=script&lang=js&"
export * from "./CCModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010e2b84",
  null
  
)

export default component.exports